<template>
  <div>
    <b-alert
      show
      variant="light"
      class="margin-bottom font14px icon-dark-custom"
    >
      <h6>ตรวจสอบการเดินทางเข้าออกประเทศ</h6>
      <div>
        {{
          "สัญชาติ : " +
            this.MyNationality +
            " | บัตรประชาชน : " +
            this.MyCid +
            " | Passport No : " +
            this.MyPassportno
        }}
      </div>
      <div v-if="TmpDataNHSO.length <= 0">
        <h2 class="font-color-danger">ไม่พบข้อมูล</h2>
      </div>
      <div>
        <b-table
          striped
          hover
          small
          :items="TmpDataNHSO"
          :fields="TmpfieldsNHSO"
          class="font14px"
          head-variant="dark"
          bordered
          responsive
        >
        </b-table>
      </div>
    </b-alert>
    <div class="d-block text-center">
      <b-button
        variant="info"
        size="sm"
        class="d-print-none"
        v-print="'#modal-moph-immigration-data'"
      >
        Print
      </b-button>
      &nbsp;
      <b-button
        size="sm"
        class="d-print-none"
        @click="$bvModal.hide('modal-moph-immigration-data')"
        >Close</b-button
      >
    </div>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";
import DocumentScan from "@/models/patientEMRs/DocumentScan";

Vue.use(feather, "v-icon");

@Component({
  data() {
    return {
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      TmpDataNHSO: [],
      TmpfieldsNHSO: [],
      urlStrCid: "",
      urlStr: "",
      urlMain: ""
    };
  },
  props: ["MyCid", "MyNationality", "MyPassportno"],
  component: {
    thaiDatetime,
    pjFunctions
  },
  created() {
    this.thaiDatetimeFc = thaiDatetime.methods;
    this.pjFunctionsFc = pjFunctions.methods;
    this.setMophImmigration(this.MyCid);
  },
  watch: {
    MyCid: function() {
      this.setMophImmigration(this.MyCid);
    }
  },
  computed: {},
  methods: {
    setMophImmigration(cid) {
      this.urlStrCid =
        "https://smarthealth.service.moph.go.th/phps/api/immigration/v1/citizenid/";
      this.urlStrDocNo =
        "https://smarthealth.service.moph.go.th/phps/api/immigration/v1/documentno/";

      if (this.MyPassportno != "") {
        this.urlMain = this.urlStrDocNo + this.MyPassportno;
      } else {
        this.urlMain = this.urlStrCid + this.MyCid;
      }

      if (this.MyNationality == "ไทย") {
        this.urlMain = this.urlStrCid + this.MyCid;
      } else {
        this.urlMain = this.urlStrDocNo + this.MyPassportno;
      }

      let ScrObj = this;

      this.axios
        .get(this.urlMain, {
          headers: {
            "JWT-TOKEN": this.$store.get("systems@mophUser").moph_token
          }
        })
        .then(function(response) {
          ScrObj.output = response.data;
          if (ScrObj.output.length > 0) {
            ScrObj.TmpDataNHSO = [];

            // console.log(ScrObj.output);

            let kk = ScrObj.Arrayfilter(ScrObj.output, "ขาเข้า");

            let mophDt = kk[0];

            ScrObj.TmpDataNHSO.push({
              list: "GIVENNAME",
              listDetail: mophDt.GIVENNAME
            });

            ScrObj.TmpDataNHSO.push({
              list: "MIDDLENAME",
              listDetail: mophDt.MIDDLENAME
            });

            ScrObj.TmpDataNHSO.push({
              list: "SURNAME",
              listDetail: mophDt.SURNAME
            });

            ScrObj.TmpDataNHSO.push({
              list: "SEX",
              listDetail: mophDt.SEX
            });

            ScrObj.TmpDataNHSO.push({
              list: "DOCUMENTTYPE",
              listDetail: mophDt.DOCUMENTTYPE
            });

            ScrObj.TmpDataNHSO.push({
              list: "DOCUMENTNO",
              listDetail: mophDt.DOCUMENTNO
            });

            ScrObj.TmpDataNHSO.push({
              list: "FLIGHTNO",
              listDetail: mophDt.FLIGHTNO
            });

            ScrObj.TmpDataNHSO.push({
              list: "CITIZENID",
              listDetail: mophDt.CITIZENID
            });

            ScrObj.TmpDataNHSO.push({
              list: "COUNTRY",
              listDetail: mophDt.COUNTRY
            });

            ScrObj.TmpDataNHSO.push({
              list: "NATION",
              listDetail: mophDt.NATION
            });

            ScrObj.TmpDataNHSO.push({
              list: "PROVINCE",
              listDetail: mophDt.PROVINCE
            });

            let d1 = new Date(mophDt.TRAN_DATE);

            ScrObj.TmpDataNHSO.push({
              list: "TRAN_DATE",
              listDetail: ScrObj.thaiDatetimeFc.ThaiDateTime(
                ScrObj.thaiDatetimeFc.DateTimeToStrDatetime(d1)
              )
            });

            ScrObj.TmpDataNHSO.push({
              list: "TRANSACTIONTYPE",
              listDetail: mophDt.TRANSACTIONTYPE
            });

            ScrObj.TmpDataNHSO.push({
              list: "DEPARTMENT",
              listDetail: mophDt.DEPARTMENT
            });

            ScrObj.TmpDataNHSO.push({
              list: "DATE_OF_BIRTH",
              listDetail: ScrObj.thaiDatetimeFc.ThaiDate(mophDt.DATE_OF_BIRTH)
            });

            let d3 = new Date(mophDt.CREATE_DATE);

            ScrObj.TmpDataNHSO.push({
              list: "CREATE_DATE",
              listDetail: ScrObj.thaiDatetimeFc.ThaiDateTime(
                ScrObj.thaiDatetimeFc.DateTimeToStrDatetime(d3)
              )
            });

            ScrObj.TmpDataNHSO.push({
              list: "CREATE_BY",
              listDetail: mophDt.CREATE_BY
            });

            let d2 = new Date(mophDt.UPDATE_DATE);

            ScrObj.TmpDataNHSO.push({
              list: "UPDATE_DATE",
              listDetail: ScrObj.thaiDatetimeFc.ThaiDateTime(
                ScrObj.thaiDatetimeFc.DateTimeToStrDatetime(d2)
              )
            });

            ScrObj.TmpDataNHSO.push({
              list: "UPDATE_BY",
              listDetail: mophDt.UPDATE_BY
            });

            /*
            ScrObj.TmpDataNHSO.push({
              list: "บัตรประชาชน",
              listDetail: ScrObj.output.result.cid
            });
            */
          }
        })
        .catch(function(error) {
          ScrObj.output = error;
          console.log("moph-immigration : " + ScrObj.output);
        })
        .finally(function() {});
    },
    Arrayfilter(arData, ch) {
      var value = [];

      if (arData != null) {
        value = arData.filter(item => {
          return item.TRANSACTIONTYPE == ch;
        });
      } else {
        value = [];
      }

      return value;
    }
  }
})
export default class EmrCheckMophImmigration extends Vue {}
</script>

<style lang="scss">
.alert {
  margin-bottom: 0px !important;
}

.icon-css {
  margin-right: 4px;
  float: left;
}
</style>

